<template>
  <div id="app">
    <router-view />
    <InvisibleWatermark />
  </div>
</template>

<script>
import InvisibleWatermark from '@/components/InvisibleWatermark.vue'

export default {
  components: {
    InvisibleWatermark
  }
}
</script>

<style lang="less" scoped>
// 样式穿透 设置表格边框的样式
// @media screen and (max-width: 1080px) {
//   :deep(.ant-table-thead) > tr > th,
//   :deep(.ant-table-tbody) > tr > td {
//     padding: 16px 0px 16px 4px;
//   }
// }
</style>
